export default __webpack_public_path__ + "static/media/CodeClan-Careers-01.d5ca5285.png";